import React, {useEffect} from 'react';
import {
    checkPageNameExists,
    checkHasSpaces,
    checkIfEmpty
} from '../../../validations/validations'
import PopUpValidationCore from './PopUpValidationCore';

const returnNewPageName = () => {

    const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
    let tempDataLength = JSON.parse(localStorage.getItem('data'))[selectedProject].pages.length+1;
    while (checkPageNameExists(`Page${tempDataLength}`,selectedProject,100) === true) {
        tempDataLength += 1;
    }
    return `Page${tempDataLength}`;

}

const ClickedNewPagePopUp = (props) => {

    const{
        clickedNewPage,
        setClickedNewPage,
        selectedProject,
        newPageClicked
    }=props;

    
    const [pageName, setPageName] = React.useState('');

    useEffect( () => {
        if(clickedNewPage === true){
            const newPageName = returnNewPageName();
            setPageName(newPageName);
        } 
    },[ clickedNewPage])

    const handleCancel = () => {
        setClickedNewPage(false);
    }

    const handlePageName = (val) => {
        setPageName(val.target.value);
    }

    const updateAttributes = () =>{

        if( checkIfEmpty(pageName) === false && checkHasSpaces(pageName) === false && checkPageNameExists(pageName, selectedProject,100) === false ){
            if(clickedNewPage === true){
                newPageClicked(pageName);
                setClickedNewPage(false);
            }
        }
    }

    return(
        <PopUpValidationCore
            title='Create new page'
            page_description='New page name'
            open={clickedNewPage}
            setOpen={setClickedNewPage}
            handlePageName={handlePageName}
            pageName={pageName}
            selectedProject={selectedProject}
            handleCancel={handleCancel}
            updateAttributes={updateAttributes}
            selectedPage={100}
            cause='CreatePage'
        />
    )

}

export default  ClickedNewPagePopUp;
export {
    returnNewPageName
}